import React, { Component } from 'react';
import Logic from '../../Logic';

const AuditsTable = (props) => {
    let logic = new Logic();
    let rows = props.audits.map((a,i) => <tr key={i}>
        <td>{logic.formatDate(a.createdOn)}</td>
        <td>{a.action}</td>
        <td>{a.displayname} ({a.owner})</td>
    </tr>);
    return(
        <div>
            <table className="table-bordered table-sm col-md-12">
            <thead className="thead-light">
                <tr>
                    <th>תאריך</th>
                    <th>פעולה</th>
                    <th>מבצע הפעולה</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
            </table>
        </div>
        );
  };

export default AuditsTable;